const termsHtml = `
<h2>Terms and Conditions</h2>
<p><strong>Effective Date:</strong> March 1, 2025</p>

<p>Welcome to Jobque.ai ("Company," "we," "our," or "us"). By accessing or using our website, applications, products, and services ("Services"), you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree, please do not use our Services.</p>

<h3>Acceptance of Terms</h3>
<p>By using our Services, you confirm that you have read, understood, and agree to be bound by these Terms, our Privacy Policy, and our Cookie Policy.</p>

<h3>Eligibility</h3>
<p>You must be at least 18 years old to use our Services.</p>

<h3>Services Description</h3>
<p>Jobque.ai helps job seekers automatically find matching job openings by tracking the career pages of their choice.</p>

<h3>Privacy and Data Protection</h3>
<p>Your privacy is important to us. We comply with GDPR, CCPA, and other applicable laws. We collect only necessary personal information, including your name and email address, to deliver and improve our Services. We do not sell your personal information. Full details are available in our Privacy Policy.</p>

<h3>User Conduct</h3>
<p>You agree to use the Services lawfully and respectfully. You agree not to:</p>
<ul>
  <li>Violate laws or regulations</li>
  <li>Infringe on intellectual property rights</li>
  <li>Disrupt our Services or servers</li>
</ul>

<h3>Payments and Refund Policy</h3>
<p>Payments are processed securely via Stripe. All purchases are final, and we operate a "No Refunds" policy unless otherwise required by law.</p>

<h3>Intellectual Property</h3>
<p>All content and materials provided by Jobque.ai are the exclusive property of the Company. You may not copy, modify, or distribute our content without permission.</p>

<h3>Account Management</h3>
<p>You may be required to create an account to use certain Services. You are responsible for maintaining the confidentiality of your login information. You may request account deletion by contacting <a href="mailto:legal@jobque.ai">legal@jobque.ai</a>.</p>

<h3>Third-Party Services</h3>
<p>We use third-party services like Stripe for payments and Google Analytics for data analysis. Their terms and policies also apply.</p>

<h3>Cookies</h3>
<p>By using our website, you agree to our use of cookies as outlined in our Cookie Policy.</p>

<h3>Disclaimers</h3>
<p>Our Services are provided "as is" without warranties of any kind. We do not guarantee the availability, accuracy, or reliability of our Services.</p>

<h3>Limitation of Liability</h3>
<p>To the fullest extent allowed by law, Jobque.ai shall not be liable for any indirect, incidental, or consequential damages arising from your use of our Services.</p>

<h3>Indemnification</h3>
<p>You agree to indemnify and hold harmless Jobque.ai, its affiliates, officers, employees, and agents from any claims or liabilities arising from your use of the Services or violation of these Terms.</p>

<h3>Modifications</h3>
<p>We may update these Terms at any time. Changes are effective upon posting. Continued use of the Services after changes constitutes your acceptance.</p>

<h3>Governing Law</h3>
<p>These Terms are governed by the laws of Canada without regard to its conflict of law principles.</p>

<h3>Contact Us</h3>
<p>For any questions, please contact us at: <a href="mailto:legal@jobque.ai">legal@jobque.ai</a>.</p>

<hr>

<h2>Privacy Policy</h2>
<p><strong>Effective Date:</strong> March 1, 2025</p>

<p>At Jobque.ai, we prioritize your privacy and are committed to protecting your personal data.</p>

<h3>Information We Collect</h3>
<ul>
  <li>Personal Information: Name and Email Address.</li>
  <li>Automatically Collected Information: Cookies, usage data, and device information.</li>
</ul>

<h3>How We Use Your Information</h3>
<ul>
  <li>To provide, operate, and improve our Services.</li>
  <li>To communicate with you.</li>
  <li>To ensure compliance with applicable laws.</li>
</ul>

<h3>Sharing Your Information</h3>
<p>We do not sell your personal information. We only share data with trusted service providers like Stripe (for payments) and Google Analytics (for website analytics).</p>

<h3>Data Security</h3>
<p>We implement industry-standard security measures to protect your data.</p>

<h3>Your Rights</h3>
<ul>
  <li>Access your data</li>
  <li>Correct your data</li>
  <li>Delete your data</li>
  <li>Object to processing</li>
</ul>
<p>To exercise these rights, please contact <a href="mailto:legal@jobque.ai">legal@jobque.ai</a>.</p>

<h3>International Data Transfers</h3>
<p>We operate globally. By using our Services, you consent to the transfer of information to countries outside your country of residence.</p>

<h3>Cookies</h3>
<p>We use cookies to improve your experience. Please see our Cookie Policy.</p>

<h3>Changes to this Policy</h3>
<p>We may update this Privacy Policy. Changes are effective upon posting.</p>

<h3>Contact Us</h3>
<p>For any privacy-related questions, contact <a href="mailto:legal@jobque.ai">legal@jobque.ai</a>.</p>

<hr>

<h2>Cookie Policy</h2>
<p><strong>Effective Date:</strong> March 1, 2025</p>

<p>Jobque.ai uses cookies to enhance your browsing experience. By using our site, you consent to our use of cookies.</p>

<h3>What are Cookies?</h3>
<p>Cookies are small text files stored on your device to help us improve our Services.</p>

<h3>How We Use Cookies</h3>
<ul>
  <li>Remember user preferences</li>
  <li>Understand user behavior</li>
  <li>Improve site functionality</li>
</ul>

<h3>Managing Cookies</h3>
<p>You can disable cookies through your browser settings, but some functionalities may be limited.</p>

<h3>Contact</h3>
<p>For any questions about our Cookie Policy, please contact <a href="mailto:legal@jobque.ai">legal@jobque.ai</a>.</p>

<p><strong>"By continuing, you agree to our Terms and Conditions, Privacy Policy, and Cookie Policy."</strong></p>
`;

export default termsHtml;
